import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FlexDirective } from '@ngbracket/ngx-layout/flex';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatDivider } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-is-maes-diogelwch',
    templateUrl: './is-maes-diogelwch.component.html',
    styleUrls: ['./is-maes-diogelwch.component.scss'],
    imports: [FlexDirective, FaIconComponent, MatDivider, FormlyModule, TranslatePipe]
})
export class IsMaesDiogelwchComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }
//TODO ydi @for (option of (to.options | async) ?? []; track option?.value ?? option) yn gweithio?
  ngOnInit(): void {

  }
}
